import { useEffect, useMemo, useRef, useState } from "react";
import {
  useAppStore,
  useAuthStore,
  useNonPersistAuthStore,
} from "../AuthStore/AuthStore";
import LoginPage from "../Pages/Login/Login";
import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import Inputnumberdemo from "../Pages/inputnumberdemo";
import ProtectedRoute from "./ProtectedRoute";
import { API, APIwithoutInterceptor } from "../Axios/Axios";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import DyanmicFormComponent from "../Components/DynamicForm/DynamicForm";
import StateMasterDashboard from "../Pages/Masters/StateMaster/StateMasterDashboard";
import {
  getAuthenticationType,
  getPermissions,
  getUserRoles,
  SetRole,
} from "../Helpers/APIEndpoints/Endpoints";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Button, Layout, theme, Tooltip } from "antd";
import DynamicReport from "../Components/DynamicReport/DynamicReport";
import DynamicMaster from "../Components/DynamicMaster/DynamicMaster";
import InterfaceComponent from "../Pages/Masters/InterfaceComponent";
import CustomPage from "../Pages/CustomPage";
import ReportActionBuilder from "../Pages/JsonBuilder/ReportActionBuilder";
import FieldActionBuilder from "../Pages/JsonBuilder/FieldActionBuilder";
import ADUserMaster from "../Pages/ADUserMaster";
import Home from "../Pages/Home/Home";
import FormControls from "../Pages/FormControls";
import TabsAndAccordions from "../Pages/TabsAndAccordions";
import EditTable from "../Pages/JsonBuilder/CollapseAccordion";
import RegionMasterDashboard from "../Pages/Masters/RegionMaster/RegionMasterDashboard";
import PersonalDetails from "../Pages/PersonalDetails";
import AuditReporting from "../Pages/AuditReporting";
import DynamicFormAllControl from "../Pages/DynamicFormAllControl";
import EmployeeMaster from "../Pages/Masters/EmployeeMaster/EmployeeMaster";

import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import ActionTracker from "../Pages/ActionTracker";
import PerformanceRating from "../Pages/PerformanceRatings";
import DocViewInterface from "../Pages/DocViewInterface";
import MedicineControls from "../Pages/MedicineControls";
import useSessionTimeout from "./sessionTimeOut"; // NOSONAR : ignore
import { Time_OUT } from "../Helpers/APICalls/Constants"; // NOSONAR : ignore
import { logoutUser } from "./LogOut";
import SamplePage from "../Pages/SamplePage";
import DynamicMenu from "../Components/DynamicMenu";
import SchedulerReport from "../Pages/Masters/ScheduleMaster/SchedulerReport";
import ScheduleMaster from "../Pages/Masters/ScheduleMaster/ScheduleMaster";
import Workflow from "../Pages/workflow";
import SampleWorkflow from "../Pages/SampleWorkflow";
import RequestTypeMasterDashboard from "../Pages/Masters/RequestTypeMaster/RequestTypeMasterDashboard";
import BusinessChannelMasterDashboard from "../Pages/Masters/BusinessChannelMaster/BusinessChannelMasterDashboard";
import RequestCategoryMasterDashboard from "../Pages/Masters/RequestCategoryMaster/RequestCategoryMasterDashboard";
import ProductTypeMasterDashboard from "../Pages/Masters/ProductTypeMaster/ProductTypeMasterDashboard";
import RequestDashboard from "../Pages/RequestDashboard/RequestDashboard";
import RequestDetailInterface from "../Pages/RequestDashboard/RequestDetailInterface";
import SLAMappingMasterDashboard from "../Pages/Masters/SLAMaster/SLAMappingMasterDashboard";
import HolidayMaster from "../Pages/Masters/HolidayMaster/HolidayMaster";
import UserMaster from "../Pages/Masters/UserMaster/UserMaster";
import DetailedRequestReport from "../Pages/Reports/DetailedRequestReport";
import ResolutionMetricsReport from "../Pages/Reports/ResolutionMetricsReport";
import TaskOwnerPerformanceReport from "../Pages/Reports/TaskOwnerPerformanceReport";

import { useMsal } from "@azure/msal-react";
import TaskDashboard from "../Pages/TaskDashboard/TaskDashboard";
import { RoleEnum } from "../Enum/RoleEnum";
import PowerBIReport from "../Pages/Reports/TestPowerBIReport";

export const AllRoutes = {
  Home: { link: "/Home", title: "Home", pname: "Home" },
};

const RoutesComponent = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const siderRef = useRef(null);
  const { instance } = useMsal();

  const { Header, Sider, Content, Footer } = Layout;

  // Detect if the viewport is in mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // Adjust for "lg" breakpoint
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate();

  const [loginType, setLoginType] = useState<string | null>(null); // State to hold the login type
  const {
    setCommonContextRoleId,
    commonContextParams,
    setredirectUrlPostLogin,
    redirectUrlPostLogin,
    setPermissionContext,
  } = useAuthStore();
  const location = useLocation();
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [roles, setRoles] = useState<any>(null);
  const [nameOfUser, setNameOfUser] = useState<any>("");
  const [menuCall, setmenuCall] = useState(0);
  const CurrentroleId = commonContextParams?.roleId;

  useEffect(() => {
    if (commonContextParams.roleId) {
      console.log(
        "Setting selected role from context:lll",
        commonContextParams,
      );
      setSelectedRole(commonContextParams.roleId);
    }
  }, [CurrentroleId]);

  const handleRoleChange = async (event: any) => {
    console.log("Selected Role Value:", event.target.value);
    const selectedValue = event.target.value;
    await setRoleApiCall(selectedValue);
    setSelectedRole(selectedValue);
    setCommonContextRoleId(selectedValue);
    selectedValue == RoleEnum.TaskOwner
      ? navigate("/TaskDashboard")
      : navigate("/RequestDashboard");
    window.location.reload();
  };
  const handleLogout = async () => {
    // reset in-memory state for all stores (fast + no refactor)
    useAuthStore.persist.clearStorage();

    // reset fields (MERGE update, no "true")
    useAuthStore.setState({
      commonContextParams: { username: null, userId: null, roleId: null },
      permissionContext: null,
      redirectUrlPostLogin: null,
    });

    // reset other stores
    useAppStore.setState({ surveyId: 0 });
    // IMPORTANT: sign out from Entra + MSAL cache
    instance.setActiveAccount(null); // optional but good hygiene :contentReference[oaicite:1]{index=1}
    await instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin + "/", // or "/logged-out"
    });
    useNonPersistAuthStore.setState({ Jwtaccesstoken: "" });

    logoutUser(commonContextParams?.username, navigate);
  };

  useEffect(() => {
    if (CurrentroleId && CurrentroleId !== "") {
      const fetchUserRolePermissions = async () => {
        try {
          const response = await API.post(getPermissions, {
            RoleId: CurrentroleId,
          });

          // Parse the JSON response
          const data = await response.data?.data;

          setPermissionContext(
            data.map((d: { PermissionName: any }) => d.PermissionName),
          );
          setmenuCall(1);
          // Set the parsed authentication object in state
        } catch (error) {
          console.error("Failed to fetch login type:", error);
        }
      };

      fetchUserRolePermissions();
    }
    // Function to fetch login type from the API
  }, [CurrentroleId]);

  useEffect(() => {
    if (commonContextParams?.userId) {
      const fetchUserRoles = async () => {
        try {
          const response = await API.post(getUserRoles, {
            UserId: commonContextParams?.userId,
          });

          // Parse the JSON response
          const data = await response.data?.data;
          let roleOptions = data.map((d: { Name: string; Id: string }) => ({
            label: d.Name,
            value: parseInt(d.Id),
          }));

          if (roleOptions) {
            setRoles(roleOptions);
            console.log("commonContextParams:", commonContextParams);
            await setRoleApiCall(commonContextParams?.roleId);
            setSelectedRole(commonContextParams?.roleId);
            setCommonContextRoleId(commonContextParams?.roleId);
          }
          if (data && data.length > 0) {
            console.log("User Roles:", data);
            setNameOfUser(data[0]?.userFullName);
          }
        } catch (error) {
          console.error("Failed to fetch user role:", error);
        }
      };
      fetchUserRoles();
    }
  }, [commonContextParams?.userId]);

  const setRoleApiCall = async (roleId: any) => {
    try {
      const response = await API.post(SetRole, {
        RoleId: roleId,
      });
      if (response?.data?.status === 0) {
        console.log("Role set successfully!");
      } else {
        console.error("Error:", response?.data?.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // Function to fetch login type from the API
    const fetchLoginType = async () => {
      try {
        const response = await APIwithoutInterceptor.post(
          getAuthenticationType,
        );

        // Parse the JSON response
        const data = await response.data;

        // Set the parsed authentication object in state
        setLoginType(data.data);
      } catch (error) {
        console.error("Failed to fetch login type:", error);
      }
    };
    fetchLoginType();
  }, []);

  const safePath = (path: string) => {
    // Only allow expected characters in path, sanitize it if necessary
    const sanitized = path.replace(/[^a-zA-Z0-9\-_/]/g, "");
    return sanitized;
  };
  const currentPath = useMemo(
    () => safePath(location.pathname),
    [location.pathname],
  );
  useEffect(() => {
    if (
      !commonContextParams?.username &&
      currentPath !== "/login" &&
      currentPath !== "/forgot-password" &&
      currentPath !== "/reset-password"
    ) {
      navigate("/login");
      setredirectUrlPostLogin(currentPath); // Save the path user attempted to visit
    }
  }, [commonContextParams?.username, currentPath, redirectUrlPostLogin]);

  return (
    <>
      {/* {userInActive ? ( */}
      {currentPath === "/login" ? (
        <Routes>
          <Route
            path="/login"
            element={
              loginType ? (
                <LoginPage type={loginType} />
              ) : (
                <p>Loading login type...</p>
              )
            }
          />
        </Routes>
      ) : (
        <Layout>
          <Sider
            className="sideMenu"
            trigger={null}
            collapsible
            collapsed={collapsed}
            breakpoint="lg"
            collapsedWidth={isMobile ? 0 : 60} // 0px on mobile, 60px on desktop
            width={250} // Full width when expanded
            ref={siderRef}
            onBreakpoint={(broken) => {
              setIsMobile(broken);
            }}
          >
            <div className="scrollbar" id="custom-scroll">
              <DynamicMenu
                permission={menuCall}
                onMenuClick={() => setCollapsed(true)}
              />
            </div>
            {/* <div
              className="side_bottom"
              style={{
                display: isMobile && collapsed ? "none" : "block",
                bottom: isMobile ? "64px" : "0px",
              }}
            ></div> */}
          </Sider>
          <Layout>
            <Header
              className="header d-flex align-items-center justify-content-between"
              style={{
                padding: 0,
                background: colorBgContainer,
              }}
            >
              <div className="leftProfile d-flex align-items-center flex-direction-row">
                <Button
                  className="hamburgr_icon"
                  type="text"
                  icon={
                    collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                  }
                  onClick={() => setCollapsed(!collapsed)}
                />
                <div className="logo me-3">
                  <img src="/Images/logo.png" alt="Logo" />
                </div>
                <h2 className="portalName">R&D Helpdesk</h2>
              </div>
              <div className="rightProfile d-flex align-items-center gap-2">
                {/* <div className="mainDate mx-3"></div> */}

                <div className="">
                  <select
                    className="role-dropdown form-control form-select"
                    name={"RoleList"}
                    value={selectedRole}
                    onChange={(e: any) => handleRoleChange(e)}
                  >
                    {roles?.map((role: any) => (
                      <option key={role?.id} value={role?.value}>
                        {role?.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",                     
                  }}
                ></div> */}
                <div className="logotext">{nameOfUser}</div>
                <div className="d-flex justify-content-end logoutBtn">
                  <Tooltip title="Logout" placement="bottom">
                    <Button
                      type="text"
                      icon={
                        <LogoutOutlined
                          style={{ fontSize: "18px", color: "#000" }}
                        />
                      }
                      onClick={handleLogout}
                    ></Button>
                  </Tooltip>
                </div>
              </div>
            </Header>

            <Content
              className="main-content"
              style={{ marginLeft: isMobile ? "16px" : "70px" }}
              onClick={() => setCollapsed(true)}
            >
              <Routes>
                <Route path="/SampleWorkflow" element={<SampleWorkflow />} />
                <Route path="/workflow" element={<Workflow />} />
                <Route
                  element={
                    <ProtectedRoute
                      role={commonContextParams.roleId}
                      allowedRoles={roles?.length ? roles : []}
                    />
                  }
                >
                  <Route path="/home" element={<Home />} />
                  <Route
                    path="/ReportActionBuilder"
                    element={<ReportActionBuilder />}
                  />
                  <Route
                    path="/FieldActionBuilder"
                    element={<FieldActionBuilder />}
                  />
                  <Route path="/Edittable" element={<EditTable />} />
                  <Route
                    path="/DynamicFormAllControl"
                    element={<DynamicFormAllControl />}
                  />
                  <Route
                    path="/DynamicFormComponent"
                    element={<DyanmicFormComponent formSections={undefined} />}
                  />
                  <Route
                    path="/DynamicReport"
                    element={
                      <DynamicReport id={0} dashboardId={0} props={undefined} />
                    }
                  />
                  <Route path="/AuditReporting" element={<AuditReporting />} />
                  <Route
                    path="/PersonalDetails"
                    element={<PersonalDetails />}
                  />
                  <Route path="/ActionTracker" element={<ActionTracker />} />
                  <Route
                    path="/PerformanceRating"
                    element={<PerformanceRating />}
                  />
                  <Route
                    path="/DocViewInterface"
                    element={<DocViewInterface />}
                  />
                  <Route
                    path="/StateMasterDashboard"
                    element={<StateMasterDashboard />}
                  />
                  <Route
                    path="/RegionMasterDashboard"
                    element={<RegionMasterDashboard />}
                  />
                  <Route
                    path="/RequestTypeMasterDashboard"
                    element={<RequestTypeMasterDashboard />}
                  />
                  <Route
                    path="/BusinessChannelMasterDashboard"
                    element={<BusinessChannelMasterDashboard />}
                  />
                  <Route
                    path="/RequestCategoryMasterDashboard"
                    element={<RequestCategoryMasterDashboard />}
                  />
                  <Route
                    path="/ProductTypeMasterDashboard"
                    element={<ProductTypeMasterDashboard />}
                  />

                  <Route
                    path="/RequestDashboard"
                    element={<RequestDashboard />}
                  />

                  <Route
                    path="/RequestDetailInterface"
                    element={<RequestDetailInterface />}
                  />

                  <Route
                    path="/SLAMappingMasterDashboard"
                    element={<SLAMappingMasterDashboard />}
                  />
                  <Route
                    path="/HolidayMasterDashboard"
                    element={<HolidayMaster />}
                  />
                  <Route
                    path="/DetailedRequestReport"
                    element={<DetailedRequestReport />}
                  />
                  <Route
                    path="/ResolutionMetricsReport"
                    element={<ResolutionMetricsReport />}
                  />
                  <Route
                    path="/TaskOwnerPerformanceReport"
                    element={<TaskOwnerPerformanceReport />}
                  />
                  <Route path="/UserDashboard" element={<UserMaster />} />
                  <Route path="/TaskDashboard" element={<TaskDashboard />} />

                  <Route
                    path="/DynamicMaster"
                    element={
                      <DynamicMaster
                        InterfaceName={"Region Master"}
                        DashboardName={"Region Dashboard"}
                      />
                    }
                  />

                  <Route
                    path="/InterfaceComponent"
                    element={<InterfaceComponent />}
                  />
                  <Route path="/CustomFrom" element={<CustomPage />} />
                  <Route path="/SampleForm" element={<SamplePage />} />
                  <Route path="/EmployeeMaster" element={<EmployeeMaster />} />
                  <Route path="/ADUserMaster" element={<ADUserMaster />} />
                  <Route path="/AccessDenied" element={<AccessDenied />} />

                  <Route path="/FormControls" element={<FormControls />} />
                  <Route
                    path="/MedicineControls"
                    element={<MedicineControls />}
                  />
                  <Route
                    path="/TabsAndAccordions"
                    element={<TabsAndAccordions />}
                  />
                </Route>

                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/inputnumberdemo" element={<Inputnumberdemo />} />

                <Route path="/SchedulerMaster" element={<SchedulerReport />} />
                <Route path="/ScheduleCreate" element={<ScheduleMaster />} />
                <Route path="/PowerBIReport" element={<PowerBIReport />} />

                {/* Default Redirect */}
                <Route
                  path="*"
                  element={
                    commonContextParams?.username ? (
                      commonContextParams?.roleId == RoleEnum.TaskOwner ? (
                        <Navigate to="/TaskDashboard" />
                      ) : (
                        <Navigate to="/RequestDashboard" />
                      )
                    ) : (
                      <Navigate to="/login" />
                    )
                  }
                />
              </Routes>
            </Content>
            <Footer className="footer">
              <p>&copy; {new Date().getFullYear()} All Rights Reserved.</p>
            </Footer>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default RoutesComponent;
